import React, { useEffect, useState } from "react";
import AOS from "aos";
import "aos/dist/aos.css";



// Excerpt titles only
export const features = [
  {
    title: "Sing to me of the man, Muse, the man of twists and turns…",
  },
  {
    title: "Midway upon the journey of our life, I found myself within a forest dark…",
  },
  {
    title: "The truth may be stretched thin, but it never breaks…",
  },
  {
    title: "Where the mind is without fear and the head is held high…",
  },
  {
    title: "Pain and suffering are always inevitable for a large intelligence and a deep heart.",
  },
  {
    title: "Many years later, as he faced the firing squad, Colonel Aureliano Buendía was to remember…",
  },
  {
    title: "The white man is very clever. He came quietly and peaceably with his religion…",
  },
  {
    title: "Memory is a funny thing. When I was in college, I spent a lot of time thinking about death.",
  },
  {
    title: "For nothing was simply one thing. The other Lighthouse was true too.",
  },
  {
    title: "Mother died today. Or, maybe, yesterday; I can’t be sure.",
  },
  {
    title: "I am nothing but a corpse now, a body at the bottom of a well.",
  },
  {
    title: "124 was spiteful. Full of a baby’s",
  },
];

// Slug helper
const generateSlug = (title) =>
  title
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");


export const Excerpts = () => {
  const [hovered, setHovered] = useState(null);

  useEffect(() => {
    AOS.init({
      duration: 900,
      easing: "ease-out-cubic",
      once: false,
    });
  }, []);

  return (
    <section id="excerpts" style={{ padding: "5rem 0", backgroundColor: "#fff" }}>
      <div className="container text-center">

        {/* Tag */}
        <div
          data-aos="fade-up"
          style={{
            display: "inline-block",
            marginBottom: "1rem",
            padding: "0.4rem 1rem",
            borderRadius: "999px",
            border: "1px solid #ddd",
            boxShadow: "0 2px 10px rgba(0,0,0,0.05)",
            fontWeight: 600,
          }}
        >
          Excerpts
        </div>

        {/* Heading */}
        <h2
          data-aos="fade-up"
          data-aos-delay="100"
          style={{
            maxWidth: "700px",
            margin: "0 auto 1rem",
            fontWeight: 700,
          }}
        >
          A Minimalist Platform for Maximum Discovery
        </h2>

        {/* Subtitle */}
        <p
          data-aos="fade-up"
          data-aos-delay="200"
          style={{
            maxWidth: "700px",
            margin: "0 auto 3rem",
            color: "#6c757d",
          }}
        >
          Focused literary excerpts designed for clarity, depth, and effortless
           exploration—without visual noise.
        </p>

        {/* Cards */}
        <div className="row g-4">
          {features.map((feature, idx) => {
            const isHovered = hovered === idx;
            const slug = generateSlug(feature.title);

            return (
              <div
                key={idx}
                className="col-12 col-md-6 col-lg-3 d-flex"
                data-aos="zoom-in"
                data-aos-delay={idx * 100}
              >
                <a
                  href={`/Excerpts/${slug}`}
                  style={{
                    width: "100%",
                    textDecoration: "none",
                    color: "inherit",
                  }}
                  aria-label={feature.title}
                >
                  <div
                    onMouseEnter={() => setHovered(idx)}
                    onMouseLeave={() => setHovered(null)}
                    style={{
                      height: "100%",
                      padding: "1rem",
                      borderRadius: "1rem",
                      backgroundColor: "#fff",
                      boxShadow: isHovered
                        ? "0 14px 35px rgba(0,0,0,0.12)"
                        : "0 4px 12px rgba(0,0,0,0.08)",
                      transform: isHovered
                        ? "translateY(-6px)"
                        : "translateY(0)",
                      transition: "transform 0.3s ease, box-shadow 0.3s ease",
                      cursor: "pointer",
                    }}
                  >
                    <p
                      style={{
                        marginBottom: "0.25rem",
                        fontWeight: 600,
                        color: isHovered ? "#000" : "#212529",
                        transition: "color 0.3s ease",
                      }}
                    >
                      {feature.title}
                    </p>
                  </div>
                </a>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
